type customWindow = typeof window & {
  env: { BASE_URL: string };
};
const envUrl = (window as customWindow).env.BASE_URL;
export const BASE_URL = envUrl;

export const STOPLIGHT_URL =
  "https://stoplight.io/mocks/avamae/fintech-cloud-web-bitline-venueadmin-v1:main/12977810";

export const endpoints = {
  auth: {
    login: `${BASE_URL}/api/v1/publicrole/authmodule/login`,
    tfalogin: `${BASE_URL}/api/v1/publicrole/authmodule/tfalogin`,
    refreshAccessToken: `${BASE_URL}/api/v1/publicrole/authmodule/refresh`,
    requestpasswordreset:
      "/api/v1/publicrole/forgottenpasswordmodule/requestpasswordreset",
    resetpassword: "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
    initialisepassword:
      "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
    requestSmsTfaCode: `${BASE_URL}/api/v1/publicrole/authmodule/requestsmstfacode`,
    requestTotpCode: `${BASE_URL}/api/v1/publicrole/authmodule/requesttotpqrcode`,
    enableTfa: `${BASE_URL}/api/v1/publicrole/authmodule/enabletfa`,
    autologin: `${BASE_URL}/api/v1/publicrole/authmodule/autologin`,
    verifyEmailAddress: `${BASE_URL}/api/v1/publicrole/authmodule/verifyemailaddress`,
  },
  registrationmodule: {
    register: `${BASE_URL}/api/v1/publicrole/registrationmodule/registervenuegroup`,
    details: `${BASE_URL}/api/v1/publicrole/registrationmodule/venuegroupregistrationdetails`,
    verify: `${BASE_URL}/api/v1/publicrole/registrationmodule/validatevenuegroupuser`,
  },
  cashiersmodule: {
    list: `${BASE_URL}/api/v1/venueadminrole/cashiersmodule/list`,
    create: `${BASE_URL}/api/v1/venueadminrole/cashiersmodule/create`,
    edit: `${BASE_URL}/api/v1/venueadminrole/cashiersmodule/edit`,
    view: `${BASE_URL}/api/v1/venueadminrole/cashiersmodule/view`,
    delete: `${BASE_URL}/api/v1/venueadminrole/cashiersmodule/delete`,
  },
  managersmodule: {
    list: `${BASE_URL}/api/v1/venueadminrole/managersmodule/list`,
    create: `${BASE_URL}/api/v1/venueadminrole/managersmodule/create`,
    edit: `${BASE_URL}/api/v1/venueadminrole/managersmodule/edit`,
    view: `${BASE_URL}/api/v1/venueadminrole/managersmodule/view`,
    delete: `${BASE_URL}/api/v1/venueadminrole/managersmodule/delete`,
  },
  customers: {
    list: "/api/v1/venueadminrole/customersmodule/list",
    view: "/api/v1/venueadminrole/customersmodule/view",
    // GET loads the panel, POST saves. Same path for both - the access element that
    // guards them is matched on path only, not method.
    transactionLimits: "/api/v1/venueadminrole/customersmodule/transactionlimits",
  },
  customerTransfers: {
    listTransfers: "/api/v1/venueadminrole/customertransfersmodule/list",
    transferDetails: "/api/v1/venueadminrole/customertransfersmodule/view",
  },
  guaranteesmodule: {
    pendinglist: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/pendinglist`,
    approvedlist: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/approvedlist`,
    lockedlist: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/lockedlist`,
    declinedlist: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/declinedlist`,
    history: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/history`,
    view: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/view`,
    approve: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/approve`,
    decline: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/decline`,
    download: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/download`,
    pendingGuaranteesCount: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/pendingcount`,
    comments: `${BASE_URL}/api/v1/venueadminrole/guaranteesmodule/comments`,
  },
  cashierActions: {
    lock: "/api/v1/cashierrole/cashieractionsmodule/lockguarantee",
    unlock: "/api/v1/cashierrole/cashieractionsmodule/unlockguarantee",
    lockGuaranteeDetails:
      "/api/v1/cashierrole/cashieractionsmodule/lockguaranteedetails",
    unlockGuaranteeDetails:
      "/api/v1/cashierrole/cashieractionsmodule/unlockguaranteedetails",
  },
  profile: {
    requestSmsTfaCode: "/api/v1/venueadminrole/profilemodule/requestsmstfacode",
    changePassword: "/api/v1/venueadminrole/profilemodule/updatepassword",
    updateAppTFA: "/api/v1/venueadminrole/profilemodule/updateapptfa",
    enableSMSTFA: "/api/v1/venueadminrole/profilemodule/enablesmstfa",
    disableTFA: "/api/v1/venueadminrole/profilemodule/disabletfa",
    updateTFAConfirm: "/api/v1/venueadminrole/profilemodule/updatetfaconfirm",
    userInfo: "/api/v1/venueadminrole/profilemodule/userinfo",
  },
  dashboard: {
    guaranteeChart: "/api/v1/venueadminrole/dashboardmodule/guaranteeschart",
    storePreferences: "/api/v1/venueadminrole/dashboardmodule/guaranteeschart",
    guaranteesInfo: "/api/v1/venueadminrole/dashboardmodule/guaranteesinfo",
  },
  analytics: {
    filters: "/api/v1/venueadminrole/analyticsmodule/filters",
    overview: "/api/v1/venueadminrole/analyticsmodule/overview",
    transactionVolume: "/api/v1/venueadminrole/analyticsmodule/transactionvolume",
    averageTransaction: "/api/v1/venueadminrole/analyticsmodule/averagetransaction",
    topTransactingUsers: "/api/v1/venueadminrole/analyticsmodule/toptransactingusers",
    totalCryptoDeposited: "/api/v1/venueadminrole/analyticsmodule/totalcryptodeposited",
    conversionRates: "/api/v1/venueadminrole/analyticsmodule/conversionrates",
    averageDeposit: "/api/v1/venueadminrole/analyticsmodule/averagedeposit",
    topDepositingUsers: "/api/v1/venueadminrole/analyticsmodule/topdepositingusers",
    highRiskDeposits: "/api/v1/venueadminrole/analyticsmodule/highriskdeposits",
    userEngagement: "/api/v1/venueadminrole/analyticsmodule/userengagement",
    venueBreakdown: "/api/v1/venueadminrole/analyticsmodule/venuebreakdown",
    transactionsBreakdown: "/api/v1/venueadminrole/analyticsmodule/transactionsbreakdown",
    download: "/api/v1/venueadminrole/analyticsmodule/download",
  },
  reports: {
    list: "/api/v1/venueadminrole/reportsmodule/list",
    download: "/api/v1/venueadminrole/reportsmodule/download",
    view: "/api/v1/venueadminrole/reportsmodule/view",
  },
  external: {
    reportData: `${BASE_URL}/api/v1/externalrole/pdfreportsmodule/guaranteedetails`,
  },
  verification: {
    getFormData: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/getverificationform`,
    saveFormData: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/saveverificationform`,
    backForm: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/backverification`,
    submitForm: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/submitverificationform`,
    submitTerms: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/accepttcs`,
    verificationStatus: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/verificationstatus`,
    // verifyPersonalDetails: `${BASE_URL}/api/v1/publicrole/registrationmodule/validatepersonaldetails`,
    getDocumentList: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/documentlist`,
    uploadDocument: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/uploaddocument`,
    // documentTemplate: `${BASE_URL}/api/v1/customerrole/businessmodule/documenttemplate`,
    getDropdownData: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/dropdowndata`,
    uploadFormDocument: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/uploadformdocument`,
    deleteFormDocument: `${BASE_URL}/api/v1/venuegrouprole/venuegroupsmodule/deleteformdocument`,
  },
  jumiomodule: {
    getExternalJumioLink:
      "/api/v1/publicrole/significantpartiesjumiomodule/verificationstatus",
  },
  signalR: `${BASE_URL}/nm-hub`,
};
